<template>
    <div class="h-100 bg-white bd-radius-5">
        <b-card-body>
            <b-card-text class="p-0 scroll-bar-pop card-tab">
                <form @submit.prevent="validateForm">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    ประเภทขนส่ง
                                </label>
                                <v-select 
                                    class="w-100"
                                    label="name"
                                    v-model="tmpCheckPrice.categoryCode"
                                    :disabled="true"
                                    :options="categoryCourier"
                                    :reduce="category => category.code"
                                ></v-select> 
                            </div>
                        </div>
                        <div v-if="tmpCheckPrice.categoryCode === 'DOMESTIC'" class="col-lg-12">
                            <div>
                                <div class="form-group">
                                    <label>
                                        ที่อยู่ต้นทาง
                                    </label>
                                    <AutocompletesAddressV2 
                                        :address="{
                                            'sub-district': tmpCheckPrice.fromAddress.district,
                                            district: tmpCheckPrice.fromAddress.state,
                                            province: tmpCheckPrice.fromAddress.province,
                                            postcode: tmpCheckPrice.fromAddress.postcode,
                                        }"
                                        @setSelectedAddress="setSelectedAddressFrom"
                                    />
                                </div>
                            </div>
                            <div>
                                <div class="form-group">
                                    <label>
                                        ที่อยู่ปลายทาง
                                    </label>
                                    <AutocompletesAddressV2
                                        :classError="submitForm && $v.tmpCheckPrice.toAddress.district.$error"
                                        @setSelectedAddress="setSelectedAddressTo"
                                    />
                                    <div
                                        v-if="submitForm && !$v.tmpCheckPrice.toAddress.district.required"
                                        class="invalid-th-address"
                                    >
                                        กรุณากรอกที่อยู่ปลายทาง
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="col-lg-12">
                            <div>
                                <div class="form-group">
                                    <label>
                                        ประเทศปลายทาง
                                    </label>
                                    <v-select 
                                        :options="countries" 
                                        label="text"
                                        :class="{ 'is-invalid bd-danger': submitForm && $v.tmpCheckPrice.toINTER.text.$error }" 
                                        @input="assigninputRecipient($event)"
                                        v-model="tmpCheckPrice.toINTER.text"
                                    >
                                        <template slot="selected-option" slot-scope="option">
                                            <span>
                                            {{ option.text }}
                                            </span>
                                        </template>
                                    </v-select>
                                    <div
                                        v-if="submitForm && !$v.tmpCheckPrice.toINTER.text.required"
                                        class="invalid-th-address"
                                    >
                                        กรุณากรอกที่อยู่ปลายทาง
                                    </div>
                                </div>
                            </div>                
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    น้ำหนัก {{ this.$THEME.unitKG ? '( กิโลกรัม )' : '( กรัม )' }}
                                </label>
                                <input
                                    step="0.01"
                                    type="number"
                                    placeholder="น้ำหนัก"
                                    class="form-control"
                                    v-model="tmpCheckPrice.weight"
                                    :onkeydown="$THEME.unitKG ? 'return event.keyCode !== 69 && event.keyCode !== 189' : 'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                    :class="{ 'is-invalid': submitForm && $v.tmpCheckPrice.weight.$error}"
                                />
                                <div
                                    v-if="submitForm && !$v.tmpCheckPrice.weight.required"
                                    class="invalid-feedback"
                                >
                                    กรุณากรอกน้ำหนัก
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <AutoBox
                                :listSize="listSize"
                                :size="tmpCheckPrice.dimension.size"
                                :weight.sync="tmpCheckPrice.dimension.weight"
                                :weightKG.sync="tmpCheckPrice.weightKG" 
                                :width.sync="tmpCheckPrice.dimension.width"
                                :length.sync="tmpCheckPrice.dimension.length" 
                                :height.sync="tmpCheckPrice.dimension.height" 
                                :keyBox.sync="tmpCheckPrice.dimension.keyBox"
                                :courier_key="tmpCheckPrice.courierCode" 
                            />
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    ขนาดพัสดุ (เซนติเมตร)
                                </label>
                                <div class="row">
                                    <div class="col boxs">
                                        <input
                                            type="number"
                                            min="1"
                                            placeholder="กว้าง"
                                            class="form-control"
                                            v-model="tmpCheckPrice.dimension.width"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                    <div class="col boxs">
                                        <input
                                            type="number"
                                            min="1"
                                            placeholder="ยาว"
                                            class="form-control"
                                            v-model="tmpCheckPrice.dimension.length"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                    <div class="col">
                                        <input
                                            type="number"
                                            min="1"
                                            placeholder="สูง"
                                            class="form-control"
                                            v-model="tmpCheckPrice.dimension.height"
                                            :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 190'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <b-button type="submit" variant="primary" block>
                                <i class="fas fa-circle-notch fa-spin" v-if="tmpCheckPrice.isLoading"></i>
                                ตกลง
                            </b-button>
                        </div>
                    </div>
                </form>
            </b-card-text>
        </b-card-body>
    </div>
</template>

<script>
import AutoBox from '@/components/AutoBox';
import AutocompletesAddressV2 from '@/components/Autocomplete/AddressTH/AutocompleteAddressTH_V2'
import { required } from "vuelidate/lib/validators";

export default {
    props:{
        countries: [Object, Array],
        tmpCheckPrice: Object,
        listSize: Object,
    },
    components:{
        AutoBox,
        AutocompletesAddressV2
    },
    data: () => ({
        submitForm: false,
        categoryCourier: [
            {
                code : 'DOMESTIC',
                name : 'ในประเทศ',
            },
            {
                code : 'INTER',
                name : 'ต่างประเทศ',
            }
        ],
    }),
    validations() {
        return {
          tmpCheckPrice: {
            toAddress: {
              district: this.ruleValidate.toAddress.district
            },
            weight: this.ruleValidate.weight,
            toINTER: {
              text: this.ruleValidate.toINTER.text
            }
          }
        }
    },
    computed: {
        ruleValidate() {
            let rule = {
                toAddress: {
                    district: { required }
                },
                toINTER: {
                    text: { }
                },
                weight: { required },
            }
            if(this.tmpCheckPrice.categoryCode === 'INTER') {
                rule = {
                    toAddress: {
                        district: { }
                    },
                    weight: { required },
                    toINTER: {
                        text: { required }
                    }
                }
            }
            return rule
        }
    },
    methods:{
        assigninputRecipient(event) {
            this.tmpCheckPrice.toINTER = {}
            this.tmpCheckPrice.toINTER.text = event.text
            this.tmpCheckPrice.toINTER.alpha_2_code = event.alpha_2_code
            this.tmpCheckPrice.toINTER.alpha_3_code = event.alpha_3_code
            this.tmpCheckPrice.toINTER.calling_code = event.calling_code
            this.tmpCheckPrice.toINTER.destination_supported = event.destination_supported
            this.tmpCheckPrice.toINTER.id = event.id
            this.tmpCheckPrice.toINTER.manufacturer_supported = event.manufacturer_supported
        },
        validateForm(){
            this.submitForm = true
            this.$v.tmpCheckPrice.$touch();
            if (this.$v.tmpCheckPrice.$invalid) {
                return false
            }
            this.submitForm = false
            if(this.tmpCheckPrice.categoryCode === 'DOMESTIC') {
                this.$emit('getListCourier')
            }else if (this.tmpCheckPrice.categoryCode === 'INTER') {
                this.$emit('getListCourierInter')
            }
        },
        setSelectedAddressFrom(address){
            if( !address ){
                return false
            }
            this.tmpCheckPrice.fromAddress.state = address.district;
            this.tmpCheckPrice.fromAddress.district = address['sub-district'];
            this.tmpCheckPrice.fromAddress.province = address.province;
            this.tmpCheckPrice.fromAddress.postcode = address.postcode;
        },
        setSelectedAddressTo(address){
            if( !address ){
                return false
            }
            this.tmpCheckPrice.toAddress.state = address.district;
            this.tmpCheckPrice.toAddress.district = address['sub-district'];
            this.tmpCheckPrice.toAddress.province = address.province;
            this.tmpCheckPrice.toAddress.postcode = address.postcode;
        }
    }
}
</script>